// Core board geometry and gameplay tuning for Pink Drop.
//
// The renderer draws in a fixed "world" coordinate space (y pointing up) and a
// shared layout function maps that space into CSS pixels. Keeping the world
// size here means the game logic, the WebGL renderer, and the DOM HUD overlay
// all agree on where things live.

export const BOARD_W = 10;
export const BOARD_H = 20;

// Total world the canvas renders: the playfield on the left and a side panel
// (hold + score + next queue) on the right.
export const PANEL_X = 11;
export const PANEL_W = 6;
export const WORLD_W = PANEL_X + PANEL_W;
export const WORLD_H = BOARD_H;

// Rectangles (in world units) for the static HUD regions. y is the bottom edge.
export const RECTS = {
  board: { x: 0, y: 0, w: BOARD_W, h: BOARD_H },
  hold: { x: 11.4, y: 15.8, w: 5.2, h: 4.2 },
  score: { x: 11.2, y: 12.2, w: 5.6, h: 3.0 },
  next: [
    { x: 11.4, y: 8.4, w: 5.2, h: 3.4 },
    { x: 11.4, y: 4.5, w: 5.2, h: 3.4 },
    { x: 11.4, y: 0.6, w: 5.2, h: 3.4 },
  ],
};

// Timing (milliseconds).
export const LOCK_DELAY = 500;
export const MAX_LOCK_RESETS = 15;
export const DAS = 150; // delayed auto shift
export const ARR = 40; // auto repeat rate
export const SOFT_DROP_INTERVAL = 40;
export const CLEAR_FLASH = 140;
export const MAX_QUEUE = 4;

// Gravity per level, in the style of the Tetris guideline curve.
export const gravityInterval = (level) => {
  const l = Math.max(0, level - 1);
  return Math.max(28, 1000 * Math.pow(0.8 - l * 0.007, l));
};
